export default "__VITE_ASSET__Ga6ZKryL__"